
import './bpp2026.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './Home';
import Programme from './Programme';
import Abstracts from './Abstracts';
import Committees from './Committees';
import Social from './Social';
import Registration from './Registration';
import Venue from './Venue';
import Sponsors from './Sponsors';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    
    <Router>
      <Navigation></Navigation>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="venue" element={<Venue />} />
        <Route path="programme" element={<Programme />} />
        <Route path="registration" element={<Registration />} />
        <Route path="abstracts" element={<Abstracts />} />
        <Route path="committees" element={<Committees />} />
        <Route path="social" element={<Social />} />
        <Route path="sponsors" element={<Sponsors />} />
      </Routes>
    </Router>
  );
}

export default App;